<template>
  <section v-if="isUpdateModal || $store.state.isEditScrisoare"
           class="delete-tratament-btn flex flex-center">

    <button @click.stop="promptDelete"
            type="button">
      <i>
        <svg width="65px" height="65px" viewBox="0 0 65 65" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <circle fill="#D8D8D8" cx="32.5" cy="32.5" r="32.5"></circle>
            <path d="M45,21.0833333 L45,22.3333333 L43.3333333,22.3333333 L41.3333333,46.5833333 C41.3333333,47.2500033 41.0972246,47.8194421 40.625,48.2916667 C40.1527754,48.7638913 39.5833367,49 38.9166667,49 L27.1666667,49 C26.5,49 25.9305579,48.7638913 25.4583333,48.2916667 C24.9861087,47.8194421 24.75,47.2500033 24.75,46.5833333 L22.75,22.3333333 L21,22.3333333 L21,21.0833333 L27.6666667,21.0833333 L27.6666667,19.4166667 C27.6666667,18.7499967 27.9027754,18.1805579 28.375,17.7083333 C28.8472246,17.2361087 29.4166633,17 30.0833333,17 L35.9166667,17 C36.5833367,17 37.1527754,17.2361087 37.625,17.7083333 C38.0972246,18.1805579 38.3333333,18.7499967 38.3333333,19.4166667 L38.3333333,21.0833333 L45,21.0833333 Z M29,19.2352941 L29,21 L37,21 L37,19.2352941 C37,18.4117606 36.6190514,18 35.8571429,18 L30.1428571,18 C29.3809486,18 29,18.4117606 29,19.2352941 Z M40.0921659,46.7704918 L42,23 L24,23 L25.9078341,46.7704918 L25.9078341,46.852459 C25.9078341,47.6174902 26.3225765,48 27.1520737,48 L38.8479263,48 C39.6774235,48 40.0921659,47.6174902 40.0921659,46.852459 L40.0921659,46.7704918 Z M32.453125,45 L32.453125,25 L33.546875,25 L33.546875,45 L32.453125,45 Z M37.9765625,25 L37.1171875,45 L36.0234375,45 L36.8046875,25 L37.9765625,25 Z M29.1171875,25 L29.9765625,45 L28.8828125,45 L28.0234375,25 L29.1171875,25 Z" fill="#FFFFFF" fill-rule="nonzero"></path>
          </g>
        </svg>
      </i>
    </button>

    <div class="prompt-delete"
         v-if="isDeletePrompt">
      <p>Sunteți sigur că doriți să ștergeți acest tratament?</p>
      <div class="flex flex-between">
              <span class="pointer"
                    @click="promptDelete('no')">NU</span>
        <span class="pointer"
              @click.stop="deleteTratament">DA</span>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'delete-tratament-btn',

    data () {
      return {
        isDeletePrompt: false
      }
    },

    computed: {
      ...mapState({
        data: state => state.modalData,
        isUpdateModal: 'isUpdateModal'
      })
    },

    methods: {
      promptDelete (action) {
        this.isDeletePrompt = action !== 'no'
        this.$emit('set-delete-mode', action !== 'no')
      },

      deleteTratament () {
        this.$emit('delete-tratament', this.isDelete)
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/styles/mixin";
  @import "../assets/styles/var";

  .delete-tratament-btn {

    button {
      background: none!important;
      border: none;
      cursor: pointer;

      svg circle {
        transition: fill .1s ease-in-out;
      }

      &:hover {
        background-color: transparent!important;
        svg circle {
          fill: @red;
        }
      }
    }

    .prompt-delete {
      width:
        200px;
      margin-top: 20px;
      text-align: center;
      font-size: 1.3rem;
      div {
        width: 50%;
        margin: 8px auto 0;
        span {
          width: 40px;
          height: 20px;
          padding-top: 4px;
          text-align: center;
          line-height: 1.4rem;
          font-weight: bold;
          border-radius: 4px;
          color: white;
          transition: background-color .1s ease-in-out;
          &:first-child {
            background-color: @red;
            &:hover {
              background-color: darken(@red, 20%, relative);
            }
          }
          &:last-child {
            background-color: @main-green;
            &:hover {
              background-color: darken(@main-green, 20%, relative);
            }
          }
        }
      }
    }
  }
</style>
